import { Permissions } from "@evergis/api";

export const isRead = (permissions: Permissions): boolean =>
  permissions === Permissions.All ||
  permissions === Permissions.Read ||
  permissions === Permissions.ReadWrite ||
  permissions === Permissions.ReadConfigure;

export const isWrite = (permissions: Permissions): boolean =>
  permissions === Permissions.All || permissions === Permissions.Write || permissions === Permissions.ReadWrite;

export const isConfigure = (permissions: Permissions): boolean =>
  permissions === Permissions.All || permissions === Permissions.Configure || permissions === Permissions.ReadConfigure;

export const toggleRead = (permissions: Permissions): Permissions => {
  switch (permissions) {
    case Permissions.Read:
    case Permissions.ReadWrite:
    case Permissions.ReadConfigure:
      return Permissions.None;
    case Permissions.All:
      return Permissions.None;
    case Permissions.Write:
      return Permissions.ReadWrite;
    case Permissions.None:
      return Permissions.Read;
    case Permissions.Configure:
      return Permissions.ReadConfigure;
    default:
      return permissions;
  }
};

export const toggleWrite = (permissions: Permissions): Permissions => {
  switch (permissions) {
    case Permissions.Write:
      return Permissions.None;
    case Permissions.All:
      return Permissions.ReadConfigure;
    case Permissions.ReadWrite:
      return Permissions.Read;
    case Permissions.Read:
      return Permissions.ReadWrite;
    case Permissions.None:
      return Permissions.ReadWrite;
    case Permissions.ReadConfigure:
      return Permissions.All;
    default:
      return permissions;
  }
};

export const toggleConfigure = (permissions: Permissions): Permissions => {
  switch (permissions) {
    case Permissions.ReadWrite:
      return Permissions.All;
    case Permissions.Configure:
      return Permissions.None;
    case Permissions.All:
      return Permissions.ReadWrite;
    case Permissions.Read:
    case Permissions.None:
      return Permissions.ReadConfigure;
    case Permissions.ReadConfigure:
      return Permissions.Read;
    default:
      return permissions;
  }
};

export const togglePermissions = (permissions: Permissions, toggle: "read" | "write" | "configure"): Permissions => {
  return toggle === "read"
    ? toggleRead(permissions)
    : toggle === "write"
    ? toggleWrite(permissions)
    : toggleConfigure(permissions);
};
